// extracted by mini-css-extract-plugin
module.exports = {"panelWrapper":"style_panelWrapper__yYud5","panel":"style_panel___HkWm"};